import { useMemo } from "react";
import { Categories } from "pages/enums";

export function useSubmissionReportCompletedOn({
  requirementTypeId,
  userRoles,
}) {
  const visible = useMemo(() => {
    return [
      Categories.CHECKR_BACKGROUND_CHECK,
      Categories.INDEPENDENT_BACKGROUND_CHECK,
      Categories.INDEPENDENT_WATCH,
      Categories.CPNW_WATCH,
    ].includes(requirementTypeId);
  }, [requirementTypeId]);

  const editable = useMemo(() => {
    if (!visible) return false;

    if (requirementTypeId == Categories.CPNW_WATCH) {
      const isCPNWReviewer = userRoles && userRoles.includes("CPNW-REVIEWER");
      return isCPNWReviewer; // Only CPNW-REVIEWER can edit
    }

    if (requirementTypeId == Categories.CHECKR_BACKGROUND_CHECK) {
      return false; // No one can edit
    }

    if (
      requirementTypeId == Categories.INDEPENDENT_WATCH ||
      requirementTypeId == Categories.INDEPENDENT_BACKGROUND_CHECK
    ) {
      const isHC = userRoles && userRoles.includes("HEALTHCARE");
      return !isHC; // HEALTHCARE cannot edit
    }

    return false; // No one can edit
  }, [requirementTypeId, userRoles, visible]);

  const approvalOptions = useMemo(() => {
    switch (requirementTypeId) {
      case Categories.CHECKR_BACKGROUND_CHECK:
        return [CONST_ApprovalOpts.Approved, CONST_ApprovalOpts.Reject];
      default:
        return [
          CONST_ApprovalOpts.Approved,
          CONST_ApprovalOpts.ConditionallyApproved,
          CONST_ApprovalOpts.Reject,
        ];
    }
  }, [requirementTypeId]);

  return {
    visible,
    editable,
    approvalOptions,
  };
}

const CONST_ApprovalOpts = {
  Approved: { value: "Approved", label: "Accept" },
  ConditionallyApproved: {
    value: "Conditionally Approved",
    label: "Conditionally Approved",
  },
  Reject: { value: "Rejected", label: "Reject" },
};
